{
  "NAME": "DirectoryModal",
  "AddDirectoryTitle": "Verzeichnis hinzufügen",
  "ModifyDirectoryTitle": "Verzeichnis ändern",
  "TelServerFormLabel": "Telefon-Server",
  "PartitionFormLabel": "Trennwand",
  "TelNumberFormLabel": "Telefon Nummer",
  "DescriptionFormLabel": "Beschreibung",
  "DirectoryAddModify_UnknownOrDeleted": "[Unbekannt oder Gelöscht]",
  "DirectoryAddModify_ServerErrorTitle": "Validierungsfehler",
  "DirectoryAddModify_ValidationWarning": "Bitte stellen Sie sicher, dass alle Felder korrekt ausgefüllt sind",
  "DirectoryAddModify_ButtonHelpLabel": "Hilfe?",
  "DirectoryAddModify_ButtonSubmitLabel": "Speichern Sie",
  "DirectoryAddModify_ButtonCancelLabel": "Abbrechen",
  "DirectoryAddModify_PromptMessage": "Sind Sie sicher, dass Sie dieses Fenster schließen wollen? Alle geänderten Konfigurationen gehen beim Schließen verloren.",
  "DirectoryAddModify_PromptConfirm": "Ja",
  "DirectoryAddModify_PromptCancel": "Abbrechen",
  "TelNumberFormLabel_Validation_Error": "Telefonnummer ist erforderlich",
  "DescriptionFormLabel_Validation_Error": "Beschreibung ist erforderlich",
  "DirectoryAddModify_TabsDetails": "Details"
}